import { render, staticRenderFns } from "./FeedbacksTitle.vue?vue&type=template&id=0f84170e&scoped=true"
import script from "./FeedbacksTitle.vue?vue&type=script&lang=js"
export * from "./FeedbacksTitle.vue?vue&type=script&lang=js"
import style0 from "./FeedbacksTitle.vue?vue&type=style&index=0&id=0f84170e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84170e",
  null
  
)

export default component.exports